export function OQueFazemos() {
  const services = [
    {
      number: '01',
      title: 'Estruturamos',
      description: 'Organizamos ideias, projetos e iniciativas culturais para que se tornem viáveis técnica e financeiramente.',
      icon: 'ri-building-line'
    },
    {
      number: '02',
      title: 'Executamos',
      description: 'Gerimos recursos, equipes e operações com responsabilidade, eficiência e entrega comprovada.',
      icon: 'ri-settings-3-line'
    },
    {
      number: '03',
      title: 'Potencializamos',
      description: 'Ampliamos alcance, impacto e sustentabilidade através de parcerias públicas e privadas.',
      icon: 'ri-rocket-line'
    }
  ];

  return (
    <section id="servicos" className="py-32 px-8 lg:px-20 bg-dark">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20 space-y-4">
          <span className="text-gold text-xs uppercase tracking-[0.3em] font-semibold">
            Nossos Serviços
          </span>
          <h2 className="font-display text-5xl lg:text-6xl font-bold text-white">
            O Que Fazemos
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-dark border border-gold/20 rounded-2xl p-14 hover:shadow-[0_8px_32px_rgba(212,175,55,0.2)] transition-all duration-500 group cursor-pointer"
            >
              <div className="space-y-8">
                <div className="text-[120px] font-display font-thin leading-none text-transparent bg-clip-text bg-gradient-to-br from-gold to-gold-light opacity-40 group-hover:opacity-60 transition-opacity duration-500">
                  {service.number}
                </div>

                <h3 className="text-3xl font-display font-semibold text-white">
                  {service.title}
                </h3>

                <div className="w-12 h-0.5 bg-gold"></div>

                <p className="text-gray-400 text-base leading-relaxed">
                  {service.description}
                </p>

                <div className="pt-4">
                  <i className={`${service.icon} text-4xl text-gold/60`}></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
